/* Info component on ContactUs, (emails sending) component on the Callsheet
   telling users what info will be sent  */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";

const InfoSendEmails = () => {
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center `} >SEND EMAILS INFO</h5>  
        <hr className={`mt-2 mb-0`}/> 
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> On clicking <span className={`${styles.Red}`}>Send</span> an email will be sent to all Crew 
            members and all Cast called for that day. </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> The email will contain a <span className={`${styles.Red}`}>Link</span> to 
                the Callsheet page, 
                the Shoot <span className={`${styles.Red}`}>Day and Date</span>, taken from
                the Callsheet, and the <span className={`${styles.Red}`}>Production Title and Company details</span>, taken 
                from the Crew Info page.</p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Additional information can be added in 
                the <span className={`${styles.Red}`}>Message</span> input box.
            </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> If your Email List is <span className={`${styles.Red}`}>larger</span> than the remaining Daily limit or 
                you encounter an issue using the Send button,
                 the List can be <span className={`${styles.Red}`}>copied</span> and send using your own email client.
            </p>
            <hr className={`mt-2 mb-0`}/> 
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoSendEmails